import '../jquery'

window.collapseChecker = function () {
  // var storage = localStorage;

  $('.collapse').on('hidden.bs.collapse', function () {
    // storage.removeItem('open_' + this.id);
    setCookie(this.id, true);
    console.log("hide + " + getCookie(this.id));
  });

  $('.collapse').on('shown.bs.collapse', function () {
    // storage.setItem('open_' + this.id, true);
    setCookie(this.id, false);
    console.log("show + " + getCookie(this.id));

  });

  // $('.simple_form.search :input').change(function () {
  //     $('.simple_form.search').trigger('submit.rails');
  // });
  //
  // $("input[name='search[zoom]']").change(function () {
  //     $("#search_date_to").val("");
  // });

  // $('#search_date_from').on('blur', function () {
  //     $('.simple_form.search').trigger('submit.rails');
  // });
  $('#search_date_to').on('blur', function () {
    // $('.simple_form.search').trigger('submit.rails');

    if ($('#search_date_to').val()) {
      $("#zoom_period_group label").removeClass('active');
    }
  });
}

$(document).ready(function () {
  collapseChecker();
});


function setCookie(c_name, value) {
  // var exdate = new Date();
  // exdate.setDate(exdate.getDate() + 360);
  // var c_value = escape(value) + ((360 == null) ? "" : "; expires=" + exdate.toUTCString());
  document.cookie = c_name + "=" + value;
}

function getCookie(c_name) {
  var i, x, y, ARRcookies = document.cookie.split(";");
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
    x = x.replace(/^\s+|\s+$/g, "");
    if (x == c_name) {
      return unescape(y);
    }
  }
}
